
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.002 18.76h-44a2 2 0 00-2 2v32a2 2 0 002 2h44a2 2 0 002-2v-32a2 2 0 00-2-2zM42 18.76v-4.001a4 4 0 00-4-4H26a4 4 0 00-4 4v4","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M56.002 32.336A47.778 47.778 0 0132 38.76 47.777 47.777 0 018 32.339","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M29 30.759h6","stroke":"#56BFC7","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    